const save = (itemId, controller) => {
  const target = document.querySelector(`#draggable-item-container-${itemId}`);
  if (!target) return false;

  return controller.stimulate('Item#update_via_frontend', target);
};

export default save;
